import React from 'react';
import { Route } from 'react-router-dom';
import { Home } from './home/Home';
import AuthRoute from '../../components/AuthRoute';
import { Login } from './auth/Login';
import { Register } from './auth/Register';
import { MerchantLayout } from './layout/MerchantLayout';
import { Workbench } from './workbench/Workbench';
import { StoreAuthorization } from './storeAuthorization/StoreAuthorization';
import { TalentSquare } from './talentSquare/TalentSquare';
import { TalentDetail } from './talentSquare/TalentDetail';
import { CreatorManager } from './creatorManager/CreatorManager';
import { Invitation } from './invitation/Invitation';
import { PrivateMessage } from './privateMessage/PrivateMessage';
import { Email } from './email/Email';
import { Script } from './script/Script';
import { UserCenter } from './userCenter/UserCenter';
import { Pricing } from './pricing/Pricing';
import { EntitlementPricing } from './pricing/EntitlementPricing';

/** Returned as a fragment so it can be composed directly inside `<Routes>`. */
export const merchantRoutes = (
  <>
    <Route path='/' element={<Home />} />
    <Route path='/creator'>
      <Route
        element={
          <AuthRoute>
            <MerchantLayout />
          </AuthRoute>
        }
      >
        <Route index element={<Workbench />} />
        <Route path='store_authorization' element={<StoreAuthorization />} />
        <Route path='talent_square' element={<TalentSquare />} />
        <Route path='talent_square/:influencerId' element={<TalentDetail />} />
        <Route path='creator_manager' element={<CreatorManager />} />
        <Route path='invitation' element={<Invitation />} />
        <Route path='private_message' element={<PrivateMessage />} />
        <Route path='email' element={<Email />} />
        <Route path='script' element={<Script />} />
        <Route path='user_center' element={<UserCenter />} />
        <Route path='upgrade' element={<Pricing />} />
        <Route path='entitlements' element={<EntitlementPricing />} />
      </Route>
      <Route path='login' element={<Login />} />
      <Route path='register' element={<Register />} />
    </Route>
  </>
);
